/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef, forwardRef, useImperativeHandle } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import propTypes from 'prop-types';

import queryString from 'query-string';
import Default from '../Default';
import Tabla from '../../componentes/Table';
import endpoints from '../../configuraciones/endpoints';
import axios from '../../configuraciones/axios';
import general from '../../configuraciones/general';
import { setRegistros, setLimpiar } from '../../ducks/listados';

const FORMULARIO = 'formulario';

const Listados = forwardRef(({
  titulo, subtitulo, mostrarLista,
  datosLista, history, location, rowSelect,
  placeHolder, cabeceros, apiKey, iconDetail, isChecked,
  parametros, customActions, mostrarCabeceroListado,
  mostrarCabeceroFormulario, guardar, cancelar, showActions,
  customClass, rowErrors, customCabecero, filtrosBusqueda,
  actionDetail, mostrar, ID, customDetailAction, params, toDo,
}, ref) => {
  const dispatch = useDispatch();
  const { registros } = useSelector(store => store.listados);
  const [filtros, setFiltros] = useState({
    txtBusqueda: '',
  });
  const paginaRef = useRef(1);
  const consultarListado = () => {
    const endpointUrl = ID ? endpoints.base.url(apiKey, ID) : endpoints.base.url(apiKey);
    axios
      .get(endpointUrl, {
        params: {
          ...filtros,
          ...parametros,
          registrosPorPagina: general.ELEMENTOS_POR_PAGINA,
          pagina: paginaRef.current || 1,
        },
      })
      .then((e) => {
        if (e.docs.length === 0 && paginaRef.current > 1) {
          history.push({ search: `?pagina=${paginaRef.current - 1}` });
        }
        dispatch(setRegistros(e));
      });
  };
  const buscar = useCallback((txtBusqueda, nuevosFiltros) => {
    history.replace({ search: `?pagina=${1}` });
    setFiltros((current) => ({ ...current, ...nuevosFiltros, txtBusqueda }));
  }, [history]);

  const obtenerPath = (id = "") => `${location.pathname}/${FORMULARIO}/${id}`;

  const irAFormulario = useCallback(({ _id }) => {
    const query = queryString.parse(window.location.hash.split("?")[1] || "");
    history.push({
      pathname: obtenerPath(_id || ""),
      state: { pagina: query.pagina || 1 },
    });
  }, []);

  const eliminar = useCallback(({ _id }) => {
    axios.delete(endpoints.base.url(apiKey, _id)).then(consultarListado);
  }, []);

  useImperativeHandle(ref, () => ({
    refrescarListado() {
      consultarListado();
    },
  }));

  useEffect(() => {
    const query = queryString.parse(location.search);
    paginaRef.current = query.pagina;
    consultarListado();
    return () => {
      dispatch(setLimpiar());
    }
  }, [filtros, location]);

  return (
    <Default
      titulo={titulo}
      placeHolder={placeHolder}
      buscar={buscar}
      guardar={guardar}
      cancelar={cancelar}
      agregar={irAFormulario}
      subtitulo={subtitulo || `${registros?.totalDocs || 0} elemento(s)`}
      mostrarLista={mostrarLista}
      datosLista={datosLista}
      customCabecero={customCabecero}
      mostrarCabeceroListado={mostrarCabeceroListado}
      mostrarCabeceroFormulario={mostrarCabeceroFormulario}
      filtrosCabeceros={filtrosBusqueda}
      mostrar={mostrar}
      params={params}
      toDo={toDo}
    >
      <Tabla
        headers={cabeceros}
        rows={registros?.docs || []}
        count={registros?.totalDocs || 0}
        onDelete={actionDetail ? false : !mostrarCabeceroFormulario && eliminar}
        onEdit={actionDetail ? false : !mostrarCabeceroFormulario && irAFormulario}
        onDetail={actionDetail && !mostrarCabeceroFormulario && (customDetailAction ? customDetailAction : irAFormulario)}
        moreActions={customActions}
        customClass={customClass}
        showActions={showActions}
        rowErrors={rowErrors}
        iconDetail={iconDetail}
        isChecked={isChecked}
        rowSelect={rowSelect}
      />
    </Default>
  );
})

Listados.propTypes = {
  /** Titulo que llevara el listado */
  titulo: propTypes.string,
  /**  */
  history: propTypes.object.isRequired,
  /** */
  location: propTypes.object.isRequired,
  /** Texto default que llevara el buscador */
  placeHolder: propTypes.string,
  /** Titulo de las columnas junto con su informacion */
  cabeceros: propTypes.array.isRequired,
  /** Apikey donde realizará la consulta de datos */
  apiKey: propTypes.string.isRequired,
  /** Flag para mostrar los cabeceros*/
  mostrarCabeceroFormulario: propTypes.bool,
  /** Parametros para realizar la busqueda*/
  parametros: propTypes.object,
  /** Agregar acciones*/
  customActions: propTypes.arrayOf(propTypes.shape({
    onClick: propTypes.string,
    icon: propTypes.string,
    validate: propTypes.func,
    transform: propTypes.func
  })),
  /** Flag para mosrar el cabecero listado*/
  mostrarCabeceroListado: propTypes.bool,
  /** Accion de guardado*/
  guardar: propTypes.func,
  /** Accion para cancelar*/
  cancelar: propTypes.func,
  /** Mostrar acciones */
  showActions: propTypes.bool,
  /** Subtitulo a mostrar */
  subtitulo: propTypes.string,
  /** Mostrar mas filtros de busqueda*/

  filtrosBusqueda: propTypes.shape({
    /** Filtro para rango de fecha (inicio -> fin) */
    fechaInicioFinal: propTypes.bool,
    /** Filtro para los tipos de evaluacion (puntual, retardo, etc..) */
    evaluacion: propTypes.bool,
    /** Filtro para los tipos de estatus (incidencia, normal) */
    estatus: propTypes.bool,
    /** Filtro para busqueda por campo de texto */
    busqueda: propTypes.bool,
    /** Boton Agregar */
    btnAgregar: propTypes.bool,
  }),

  /** Mostrar complementos de la tabla */
  mostrar: propTypes.oneOfType([propTypes.bool, propTypes.shape({
    /** Filtro para busqueda por campo de texto */
    txtBusqueda: propTypes.bool,
    /**  Subtitulo */
    Subtitulo: propTypes.bool,
    /** Boton Agregar */
    Agregar: propTypes.bool,
    /** Barra lateral (menu desplegable) */
    SideBar: propTypes.bool,
  })]),
  /** ID para realizar consultas en base del ID del usuario */
  ID: propTypes.string,
  /** Parametros para realizar la busqueda */
  params: propTypes.oneOfType([propTypes.string, propTypes.shape({
    Estatus: propTypes.string,
    Evaluacion: propTypes.string,
  })]),
  /** Funcion para realizar un accion personalizada, viene desde el padre */
  toDo: propTypes.func,
  /** Función que se va a realizar cuando se dé click al botón info */
  customDetailAction: propTypes.func,
};

Listados.defaultProps = {
  customActions: [],
  mostrarCabeceroListado: true,
  mostrarCabeceroFormulario: false,
  guardar: null,
  cancelar: null,
  showActions: false,
  actionDetail: false,
  cabeceroReporte: false,
  filtrosBusqueda: {
    /** Filtro para los tipos de movimiento (Entrada, salida) */
    movimiento: false,
    /** Filtro para rango de fecha (inicio -> fin) */
    fechaInicioFinal: false,
    /** Filtro para los tipos de evaluacion (puntual, retardo, etc..) */
    evaluacion: false,
    /** Filtro para los tipos de estatus (incidencia, normal) */
    estatus: false,
    /** Filtro para busqueda por campo de texto */
    busqueda: false,
    /** Boton Agregar */
    btnAgregar: false,
  },
  mostrar: {
    /** Filtro para busqueda por campo de texto */
    txtBusqueda: true,
    /**  Subtitulo */
    Subtitulo: true,
    /** Boton Agregar */
    Agregar: true,
    /** Barra lateral (menu desplegable) */
    SideBar: true,
  },
  showInfo: false
};

export default Listados;
